<mat-card appearance="outlined" class="main-div" *ngIf="shouldInfoShown">
    <h2><i class="fas fa-warning"></i> Zähler sind keinem Standort zugeordnet <i class="fas fa-warning"></i></h2>
    Es gab ein Update, seitdem müssen alle Zähler einem Standort zugeordnet werden. Bitte gehen Sie zur <a routerLink="/meters">Zähler Übersichtsseite</a> und aktualisieren Sie die Standortinformationen der Zähler.
</mat-card>
